<template>
  <v-app v-if="authenticated">
    <Header
      :clipped="true"
      :drawer="false"
      :fixed="true"
      :items="pages"
      ref="childComponent"
      v-if="showHeader"
    />
    <v-content>
      <router-view v-on:refreshMenu="updateMenu"></router-view>
    </v-content>
    <VersionModal v-model="showVersionModal" />
  </v-app>
</template>

<script>
import Header from "./layout/header";
import VersionModal from "./Components/VersionModal.vue";
import { initVersionCheck } from "./services/versionCheck";

export default {
  name: "app",
  components: { Header, VersionModal },

  data() {
    return {
      pages: [],
      authenticated: false,
      showVersionModal: false,
    };
  },
  computed: {
    showHeader: function () {
      return this.$store.getters.GET_showHeader;
    },
  },
  async created() {
    await this.$GAUserAuth.refreshUserInfo().then((res) => {
      this.authenticated = this.$GAUserAuth.user.isAuthenticated;
    });

    initVersionCheck(() => {
      this.showVersionModal = true;
    });
  },
  methods: {
    updateMenu() {
      this.$refs.childComponent.updateMenu();
    },
  },
};
</script>

<style scoped>
@import "./css/style.css";
</style>
